// STRICT PRODUCTION CONFIG
// We always use a relative path.
// The browser will automatically resolve this to https://iredact.suitpilot.com/api/...
export const getApiBase = () => {
  return "/api";
};
